import moment from 'moment'
import React from 'react'
import { makeStyles } from '@paintscout/ui'
import { useCalendar } from '../CalendarContext'
import MobileMonthCalendar from './MobileMonthCalendar'
import MobileEventTable from './MobileEventTable'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    minHeight: 0,
    overflow: 'hidden'
  }
}))

export default function MonthView(_props) {
  const classes = useStyles()
  const { events, setDate, date, hideWeekends } = useCalendar()

  const dayEvents = events.filter((event) => {
    if (!event.start || !event.end) return false
    return moment(event.start).isSameOrBefore(date, 'day') && moment(event.end).isSameOrAfter(date, 'day')
  })

  return (
    <div className={classes.root}>
      <MobileMonthCalendar events={events} date={date} onSelectDate={setDate} hideWeekends={hideWeekends} />
      <MobileEventTable events={dayEvents} />
    </div>
  )
}

MonthView.title = (_: Date) => {
  return ''
}

MonthView.navigate = (date: Date, action: string) => {
  switch (action) {
    case 'PREV':
      return moment(date).subtract(1, 'month').toDate()
    case 'NEXT':
      return moment(date).add(1, 'month').toDate()
    default:
      return date
  }
}
